// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import registerServiceWorker from './registerServiceWorker';

// ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import React from 'react';
import { render } from 'react-dom';
import Routers from './routers'
import { Provider } from 'react-redux';
import stores from './store/store'
import registerServiceWorker from './registerServiceWorker';


render(
    <Provider store={stores}>
        <Routers />
    </Provider>,
    document.getElementById('root')
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js